module.exports = __webpack_public_path__ + "img/画板 17.f6919f21.jpg";